import React from "react";
// import { NavLink } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { Navbar, Nav } from "react-bootstrap";

const footer = () => {
  return (
    <Navbar bg="dark" variant="dark" expand="md" fixed="bottom">
      <Nav className="mr-auto">
        <Nav.Item>
          <Nav.Link
            as={NavHashLink}
            to="/legal#top"
            scroll={el => {
              el.scrollIntoView(true);
              window.scrollBy(0, -65);
            }}
          >
            &copy; All rights reserved Chaban Medical Israel
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Nav.Item>
        <Nav.Link
          as={NavHashLink}
          to="/legal#privacy"
          scroll={el => {
            el.scrollIntoView(true);
            window.scrollBy(0, -20);
          }}
        >
          Privacy information
        </Nav.Link>
      </Nav.Item>
    </Navbar>
  );
};

export default footer;
